import { NodeBody, NodeContainer, NodeErrorIcon, NodeHeader, NodePrompts } from '@/nodes/NodeUI';
import { type GuideNodeId, outgoingHandles, RoomGroupsById, RoomTypeLabels } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import type { FC } from 'react';
import type { RoomNodeType } from './types';

const RoomNode: FC<NodeProps<RoomNodeType>> = ({ id, selected, data }) => {
    const paths = outgoingHandles.room(id as GuideNodeId, data);
    return (
        <NodeContainer>
            <NodeErrorIcon id={id} />
            <NodeHeader id={id} type={data.type} title={data.pageTitle} />
            <NodeBody selected={selected}>
                <NodePrompts prompts={data.prompts} />
                {data.roomGroupHint && (
                    <div className="flex flex-row justify-end px-3">
                        <span className="text-xs italic text-blue-600">
                            Assumed Room Group: {RoomGroupsById[data.roomGroupHint]?.label}
                        </span>
                    </div>
                )}
                {data.autoSelectRoomType && (
                    <div className="flex flex-row justify-end px-3">
                        <span className="text-xs italic text-blue-600">
                            Auto-Select: {RoomTypeLabels[data.autoSelectRoomType]}
                        </span>
                    </div>
                )}
                {/*{data.spaceComponentId && (*/}
                {/*    <div className="flex flex-col items-center justify-center p-3">*/}
                {/*        <BlockTypeDisplay typeId={data.spaceComponentId} />*/}
                {/*    </div>*/}
                {/*)}*/}
            </NodeBody>

            <Handle type="target" position={Position.Left} />
            <Handle type="source" id={paths.next} position={Position.Right} />
        </NodeContainer>
    );
};

export default RoomNode;
